import {Observable, of} from 'rxjs';
import {map, switchMap, take} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {TimeZoneConfiguration} from './timezoneconfiguration';
import {FilterResult} from '../../resource/filterresult';
import {BaseApiService} from '../../core/services/base-api.service';
import {HttpParams} from '@angular/common/http';
import {Endpoint} from '../../layout/endpoint';

@Injectable()
export class TimeZoneConfigurationService extends BaseApiService {
  public getAll(): Observable<TimeZoneConfiguration[]> {
    const objectType = this.getType('TimeZoneConfiguration');
    if (objectType == null) {
      // time zone configurations exist on MIM only
      return of([]);
    }
    const attributes = [
      this.getAttr('ObjectID'),
      this.getAttr('DisplayName'),
      this.getAttr('TimeZoneId'),
    ].filter(attr => attr !== null);

    // TimeZone doesn't use locale, so we call directly
    const params = new HttpParams()
      .append('filter', '/' + objectType)
      .append('attributes', attributes.join(','))
      .append('pageSize', '10000');

    return this.layoutService.endpoint$.pipe(
      take(1),
      switchMap((env: Endpoint) =>
        this.getDirectUrl<FilterResult>(env.getUrl() + 'v2/resources/', params),
      ),
      map(response => this.mapTimeZoneConfigurations(response.Results)),
    );
  }

  private mapTimeZoneConfigurations(searchscopes: any): TimeZoneConfiguration[] {
    let finalSearchScopes: TimeZoneConfiguration[] = [];
    searchscopes.forEach(obj => {
      finalSearchScopes.push(this.toTimeZoneConfiguration(obj));
    });
    return finalSearchScopes;
  }

  private toTimeZoneConfiguration(r: any): TimeZoneConfiguration {
    let scope = <TimeZoneConfiguration>{
      id: r[this.getAttr('ObjectID')],
      displayname: r[this.getAttr('DisplayName')],
      timezoneid: r[this.getAttr('TimeZoneId')],
    };
    return scope;
  }
}
